import { Button, Offcanvas } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { Rider } from "../../types/model";
import AthleteProfileTemplate from "./AthleteProfileTemplate";
import { RiderHistoryItem } from "./athleteProfileUtils";
import { useAthleteProfileData } from "./useAthleteProfileData";
import "./AthleteProfileDrawer.css";

interface AthleteProfileDrawerProps {
	show: boolean;
	onHide: () => void;
	riderId?: string;
	riderName?: string;
	initialRider?: Rider | null;
	initialHistory?: RiderHistoryItem[];
}

const AthleteProfileDrawer = ({
	show,
	onHide,
	riderId,
	riderName,
	initialRider,
	initialHistory,
}: AthleteProfileDrawerProps) => {
	const navigate = useNavigate();
	const location = useLocation();
	const {
		rider,
		history,
		seasonHistory,
		seasonOptions,
		selectedSeasonKey,
		setSelectedSeasonKey,
		isLoading,
		error,
	} = useAthleteProfileData({
		riderId,
		enabled: show,
		initialRider,
		initialHistory,
	});

	const handleOpenFullPage = () => {
		if (!riderId) {
			return;
		}
		onHide();
		navigate(`/riders/${riderId}`, {
			state: {
				fromPath: `${location.pathname}${location.search}`,
				fromLabel: "Edit Team",
			},
		});
	};

	return (
		<Offcanvas
			show={show}
			onHide={onHide}
			placement="end"
			scroll
			className="athlete-profile-drawer"
			data-bs-theme="dark"
			style={{ width: "min(1000px, 95vw)" }}
		>
			<Offcanvas.Header closeButton>
				<div className="d-flex justify-content-between align-items-center w-100 me-3">
					<Offcanvas.Title>Athlete Profile</Offcanvas.Title>
					<Button
						variant="outline-primary"
						size="sm"
						onClick={handleOpenFullPage}
						disabled={!riderId}
					>
						Expand
					</Button>
				</div>
			</Offcanvas.Header>
			<Offcanvas.Body className="pt-0">
				<AthleteProfileTemplate
					rider={rider}
					riderNameFallback={riderName}
					history={history}
					seasonHistory={seasonHistory}
					seasonOptions={seasonOptions}
					selectedSeasonKey={selectedSeasonKey}
					onSeasonChange={setSelectedSeasonKey}
					isLoading={isLoading}
					error={error}
				/>
			</Offcanvas.Body>
		</Offcanvas>
	);
};

export default AthleteProfileDrawer;
